import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './frontend/Login';
import HomePage from "./frontend/HomePage";
import CropRecommendationForm from './frontend/CropPredictionPage';
import Weather from './frontend/weather';
import UploadComponent from './frontend/LeafColourChart'; // Leaf Colour Chart
import NotificationComponent from './frontend/NotificationComponent';
import FertilizerRecommendation from './frontend/FertilizerRecommendation';
import Pesticide from './frontend/UploadForm';
 const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/crop" element={<CropRecommendationForm />} />
        <Route path="/fertilizer" element={<FertilizerRecommendation />} />
        <Route path="/weather" element={<Weather />} /> 
        <Route path="/lcc" element={<UploadComponent />} /> {/* ✅ Leaf Colour Chart */}
        <Route path="/notification" element={<NotificationComponent />} /> {/* ✅ Leaf Colour Chart */}
        <Route path="/pesticide" element={<Pesticide />} /> 
      </Routes>
    </Router>
  );
};
export default App;
